import { render, staticRenderFns } from "./VeeEditItem.vue?vue&type=template&id=0e47f508&"
import script from "./VeeEditItem.vue?vue&type=script&lang=js&"
export * from "./VeeEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports